import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/login/Login.vue"),
  },

  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "/home/monitoing",
        name: "Monitoing",
        component: () => import("../views/monitoring/Monitoing.vue"),
      },
      {
        path: "/home/monitoingtwo",
        name: "MonitoingTwo",
        component: () => import("../views/monitoring/MonitoingTwo.vue"),
      },
      {
        path: "/home/rights",
        name: "Rights",
        component: () => import("../views/users/Rights.vue"),
      },
      {
        path: "/home/user",
        name: "User",
        component: () => import("../views/users/User.vue"),
      },
      {
        path: "/home/cache",
        name: "DelCache",
        component: () => import("../views/users/DelCache.vue"),
      },
      {
        path: "/home/arrange",
        name: "Arrange",
        component: () => import("../views/promote/Arrange.vue"),
      },
      {
        path: "/home/calendar",
        name: "Calendar",
        component: () => import("../views/promote/Calendar.vue"),
      },
      {
        path: "/home/adminplan",
        name: "adminplan",
        component: () => import("../views/promote/Adminplan.vue"),
      },
      {
        path: "/home/daytotal",
        name: "DayStatistics",
        component: () => import("../views/statistics/DayStatistics.vue"),
      },
      {
        path: "/home/monthtotal",
        name: "MonthStatistics",
        component: () => import("../views/statistics/MonthStatistics.vue"),
      },
      {
        path: "/home/yeartotal",
        name: "YearStatistics",
        component: () => import("../views/statistics/YearStatistics.vue"),
      },
      // {
      //   path: "*",
      //   component:()=>import("../views/login/Login.vue")
      // },
    ],
  },
];

//import HelloWorld from '@/components/HelloWorld'
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new VueRouter({
  // mode: "history",
  routes,
});

export default router;
